var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTableDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.878,
    height: 24.164,
    viewBox: "0 0 18.878 24.164",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.5,
    x2: 0.5,
    y2: -0.46,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3f7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#b5d1ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: -0.17,
    x2: 0.5,
    y2: 20.658,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff5252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d50000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: -0.085,
    y2: 2.406,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    y1: -2.145,
    y2: -0.366,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    y1: -0.123,
    y2: 2.825,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    y1: -4.203,
    y2: 3.531,
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PDF",
    transform: "translate(-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5328",
    "data-name": "Path 5328",
    d: "M28.612,24.164H12.378A.378.378,0,0,1,12,23.786V.378A.378.378,0,0,1,12.378,0H24.709a.378.378,0,0,1,.267.111l3.9,3.9a.378.378,0,0,1,.111.267V23.786A.378.378,0,0,1,28.612,24.164Z",
    transform: "translate(-3.112 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5329",
    "data-name": "Path 5329",
    d: "M7,31.846l1.51-.667L9.564,32.8H7Z",
    transform: "translate(0 -19.407)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5330",
    "data-name": "Path 5330",
    d: "M27.612,24.164H11.378A.378.378,0,0,1,11,23.786V.378A.378.378,0,0,1,11.378,0H23.866L27.99,4.124V23.786A.378.378,0,0,1,27.612,24.164Z",
    transform: "translate(-2.49 0)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5331",
    "data-name": "Path 5331",
    d: "M45.076,0V3.747a.378.378,0,0,0,.378.378H49.2L47.35,1.9Z",
    transform: "translate(-23.7)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5332",
    "data-name": "Path 5332",
    d: "M21.733,41.429H7.668A.668.668,0,0,1,7,40.761V34.714H21.733a.669.669,0,0,1,.668.668v5.379A.668.668,0,0,1,21.733,41.429Z",
    transform: "translate(0 -21.608)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5333",
    "data-name": "Path 5333",
    d: "M8.51,31.179H7.668a.667.667,0,1,0,0,1.335H8.51Z",
    transform: "translate(0 -19.407)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11601",
    "data-name": "Group 11601",
    transform: "translate(10.02 14.829)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5334",
    "data-name": "Path 5334",
    d: "M15,42.215V39.627a.328.328,0,0,1,.328-.328,10.618,10.618,0,0,1,1.5.049.912.912,0,0,1,.655.949.937.937,0,0,1-.723.976,6.888,6.888,0,0,1-1,.046.105.105,0,0,0-.105.105v.791a.327.327,0,1,1-.655,0Zm.655-2.262v.709a.105.105,0,0,0,.105.105,2.871,2.871,0,0,0,.771-.051.442.442,0,0,0-.088-.847,6.4,6.4,0,0,0-.682-.022.105.105,0,0,0-.1.106Z",
    transform: "translate(-15 -39.286)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5335",
    "data-name": "Path 5335",
    d: "M23,39.619a.328.328,0,0,1,.328-.328,7.355,7.355,0,0,1,1.486.062,1.224,1.224,0,0,1,.8.824,2.4,2.4,0,0,1,.106.766,2.127,2.127,0,0,1-.1.69,1.182,1.182,0,0,1-.808.831,7.884,7.884,0,0,1-1.484.069A.328.328,0,0,1,23,42.206Zm.655.326v1.937a.105.105,0,0,0,.105.105,4.121,4.121,0,0,0,.78-.031.56.56,0,0,0,.436-.448,2.118,2.118,0,0,0,.066-.594,1.938,1.938,0,0,0-.066-.577.628.628,0,0,0-.491-.467,5.428,5.428,0,0,0-.726-.031.105.105,0,0,0-.1.106Z",
    transform: "translate(-19.98 -39.277)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5336",
    "data-name": "Path 5336",
    d: "M31.682,42.228V39.64a.328.328,0,0,1,.328-.328h1.621a.274.274,0,1,1,0,.549H32.444a.105.105,0,0,0-.105.106v.557a.105.105,0,0,0,.105.106h.974a.274.274,0,1,1,0,.549h-.974a.105.105,0,0,0-.105.105v.944a.328.328,0,0,1-.657,0Z",
    transform: "translate(-25.384 -39.299)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableDownloadIcon);
export default __webpack_public_path__ + "static/media/table-download-icon.538e745d4058b02f62e4963e4bdef9d2.svg";
export { ForwardRef as ReactComponent };